export const shortcuts = {
  CREATECUSTOMER: ["f2"],
  EDITCUSTOMER: ["f4"],
  VIEWCUSTOMER: ["f6"],
};
